import React from "react";

const Earned = ({userRelatedData}) => {

  return (
    <div className="theme-section">
      <h1 className="section-tittle">Total Earned ($ {userRelatedData.earning_related_statistics?.total_earned})</h1>
      <div className="data-table-wrapper">
        <div className="table-container">
          <table className="table">
            <tbody>
              <tr>
                <td>Last Month</td>
                <td className="text-end">$ {userRelatedData.earning_related_statistics?.current_month_earned}</td>
              </tr>
              {userRelatedData.earning_related_statistics?.last_3_months_name_and_earned?.length > 0 ?
                  userRelatedData.earning_related_statistics?.last_3_months_name_and_earned?.map((value, index) => (
                  <tr>
                    <td>{value.month_name}</td>
                    <td className="text-end">$ {value.amount}</td>
                  </tr>)):
                   <tr>No Order data available</tr>
                }
              
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Earned);
